<template>
	<el-container style="height: 100vh; border: 1px solid #eee">
		<el-aside width="250px">
			<div class="pl15 pt15 pb15 flex items-center">
				<svg fill="#000000" width="50px" height="50px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M 11.1875 6 L 10.96875 6.6875 L 5.0625 24.6875 L 4.625 26 L 11.96875 26 L 12.25 25.78125 L 18.125 21 L 19.28125 25.25 L 19.5 26 L 27.40625 26 L 26.9375 24.6875 L 20.875 6.6875 L 20.625 6 Z M 12.65625 8 L 19.1875 8 L 24.625 24 L 21 24 L 17.0625 9.46875 L 16.875 8.71875 L 15.15625 8.71875 L 14.9375 9.4375 L 12.28125 18.71875 L 11.90625 20 L 16.1875 20 L 11.28125 24 L 7.375 24 Z M 15.96875 13.09375 L 17.3125 18 L 14.5625 18 Z" />
				</svg>
				<div class="ml10 bold fs20 mt15" style="color: #636576;">ADS ADMIN</div>
			</div>
			<el-menu :default-active="activeMenu" class="el-menu-vertical-demo" @select="handleSelect">
				<el-menu-item index="1">
					<div class="pl10 pr10 pt3 pb3">
						<div class="br10 flex items-center pl15 m-nav-item">
							<i class="el-icon-menu"></i>
							<div class="flex items-center" slot="title" style="height: 44px;">Apps</div>
						</div>
					</div>
				</el-menu-item>
				<el-menu-item index="2" v-if="channel == 'fz'">
					<div class="pl10 pr10 pt3 pb3">
						<div class="br10 flex items-center pl15 m-nav-item">
							<i class="el-icon-orange"></i>
							<div class="flex items-center" slot="title" style="height: 44px;">回传</div>
						</div>
					</div>
				</el-menu-item>
				
				<!-- <el-menu-item index="3">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-position"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">API列表</div>
            </div>
          </div>
        </el-menu-item>
        <el-menu-item index="4">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-s-promotion"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">Proxy</div>
            </div>
          </div>
        </el-menu-item>
        <el-menu-item index="5">
          <div class="pl10 pr10 pt3 pb3">
            <div class="br10 flex items-center pl15 m-nav-item">
              <i class="el-icon-s-tools"></i>
              <div class="flex items-center" slot="title" style="height: 44px;">设置</div>
            </div>
          </div>
        </el-menu-item> -->
			</el-menu>
		</el-aside>

		<el-container>
			<el-header style="text-align: right;">
				<div class="mt30 flex items-center">
					<el-breadcrumb separator="/">
						<el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
						<el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
					</el-breadcrumb>
					<div class="flex-width"></div>
					<div>
						<el-button size="mini" @click="openSaveApp">创建APP</el-button>

						<el-dialog
							:visible.sync="appVisible"
							:show-close="false"
							width="40%">
							<el-form :model="form">
								<el-form-item label="应用名" :label-width="formLabelWidth">
									<el-input v-model="form.appname"></el-input>
								</el-form-item>

								<el-form-item label="包名" :label-width="formLabelWidth">
									<el-input v-model="form.package_name"></el-input>
								</el-form-item>

							</el-form>
							<span slot="footer" class="dialog-footer">
								<el-button @click="appVisible = false">取 消</el-button>
								<el-button type="primary" @click="saveApp">确 定</el-button>
							</span>
						</el-dialog>
					</div>
				</div>
			</el-header>
			<el-main>
				<router-view />
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
export default {
	data() {
		return {
			activeMenu: "1",
			menus: {
				"1": "/",
				"2": "/transsion",
				"3": "/app_list"
			},
			appVisible: false,
            formLabelWidth: "80px",
			form: {
				appname: null,
				package_name: null
			},
			channel: ""
		}
	},
	created() {
		this.channel = window.channel;
		let path = document.baseURI.substring(document.baseURI.lastIndexOf("/"));
		for (let key in this.menus) {
			if (this.menus[key] == path) {
				this.activeMenu = key;
				break;
			}
		}
	},
	methods: {
		handleSelect(key) {
			if (this.activeMenu != key) {
				this.$router.push(this.menus[key])
				this.activeMenu = key;
			}
		},
		openSaveApp() {
			this.appVisible = true;
		},
		async saveApp() {
			if (this.form.package_name == null || this.form.package_name == "" || this.form.appname == null || this.form.appname == "") {
				return;
			}
			let rs = await this.$api.create_app(this.form.package_name, this.form.appname);
			if (rs.err == 0) {
				this.$message("创建app成功");
			} else {
				this.$message("创建app失败");
			}
			this.appVisible = false;
		}
	}
}
</script>

<style>
.el-menu-vertical-demo {
	background-color: transparent !important;
}

.el-menu-vertical-demo>.el-menu-item {
	padding: 0 !important;
	height: 50px;
}

.el-menu-vertical-demo>.el-menu-item.is-active>div>.m-nav-item {
	background-color: #676cf6;
	color: white !important;
}

.m-nav-item {
	color: #636576;
}

.m-nav-item:hover {
	background-color: #eaeaed;
	color: #636576;
}

.el-main {
	padding-left: 0px !important;
}
</style>


<style lang="less" scoped>
/deep/.el-menu {
	border-right: none !important;
}
</style>